import { itemToBag, itemToBagIntent } from ".";

export const addItemToBag = item => dispatch => {
  dispatch(itemToBagIntent(item));
  dispatch(itemToBag(item));
};
